<script setup>
import { storeToRefs } from "pinia";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";
const store = useRecursosDidaticosStore();
const { disciplinas, conceitos, tiposQuestoes, niveisComplexidade, disciplinaSelecionada, conceitosSelecionados, tiposQuestoesSelecionadas, nivelComplexidadeSelecionado, apenasMeusRecursos, tabAtiva } = storeToRefs(store);

function filtrarQuestoes(){
    store.filtrarQuestoes();
}

function filtrarQuestoesEAvaliacoes(){
    store.filtrarQuestoes();
    store.filtrarAvaliacoes();
}

</script>
<template>
    <div class="flex flex-column gap-4">
        <div class="flex align-items-center gap-3">
            <InputSwitch v-model="apenasMeusRecursos" @change="filtrarQuestoesEAvaliacoes" />
            <label class="text-color">Meus Recursos</label>
        </div>
        <div v-if="tabAtiva == 0">
            <label class="mb-2 text-color block">Tipo de Pergunta</label>
            <Dropdown v-model="tiposQuestoesSelecionadas" :options="tiposQuestoes" optionLabel="nome"
                optionValue="value" class="w-full" showClear @change="filtrarQuestoes" />
        </div>
        <div v-if="tabAtiva == 0">
            <label class="mb-2 text-color block">Nível de complexidade</label>
            <Dropdown v-model="nivelComplexidadeSelecionado" :options="niveisComplexidade" optionLabel="nome"
                optionValue="id" showClear @change="filtrarQuestoes" class="w-full" />
        </div>
        <div>
            <label class="mb-2 text-color block">Disciplinas</label>
            <Dropdown v-model="disciplinaSelecionada" :options="disciplinas" optionLabel="nome" optionValue="id"
                class="w-full" @change="filtrarQuestoesEAvaliacoes" />
        </div>
        <div v-if="tabAtiva == 0">
            <label class="mb-2 text-color block">Conceitos</label>
            <MultiSelect v-model="conceitosSelecionados" :options="conceitos" filter display="chip"
                :maxSelectedLabels="3" class="w-full" @change="filtrarQuestoes" />
        </div>
    </div>
</template>